import { Module } from 'vuex-smart-module';
import PatchNotesActions from './actions';
import PatchNotesGetters from './getters';
import PatchNotesMutations from './mutations';
import PatchNotesState from './state';

export default new Module({
  state: PatchNotesState,
  mutations: PatchNotesMutations,
  actions: PatchNotesActions,
  getters: PatchNotesGetters,
});
